
























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SustainabilityImpact2409 extends Vue {
  @Prop() readonly currentLanguage!: any;
}


